import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ClassNames from 'classnames';

import { setCurrentPageTab } from '../../../../components/navbar/actions/setCurrentPageTab';

import { postLoginUser } from './actions/postLoginUser';

class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    // For testing only
    this.state = {
      username: 'example@mail.com',
      password: 'password',
      showPassword: false,
    };

    this.onSubmitLogin = this.onSubmitLogin.bind(this);
    this.onChangeText = this.onChangeText.bind(this);
    this.onClickVisible = this.onClickVisible.bind(this);
  }

  componentWillMount() {
    const currentPage = 'login';
    const activeTab = 'login';
    this.props.setCurrentPageTab(currentPage, activeTab);
  }

  onChangeText(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  onSubmitLogin(e) {
    e.preventDefault();
    const { username, password } = this.state;
    const data = {
      username: username,
      password: password,
    };
    this.props.loginUser(data);
  }

  onClickVisible() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  renderPassword() {
    const { password, showPassword } = this.state;
    return (
      <div className="control has-icons-right">
        <input
          className="input"
          type={showPassword ? 'text' : 'password'}
          name="password"
          placeholder="password"
          value={password}
          onChange={this.onChangeText}
          required
        />
        <span className="icon is-small is-right" onClick={this.onClickVisible}>
          <i
            className={ClassNames({
              fa: true,
              'fa-eye': !showPassword,
              'fa-eye-slash': showPassword,
            })}
            aria-hidden="true"
          ></i>
        </span>
      </div>
    );
  }

  render() {
    let message;
    if (this.props.message) {
      message = <p className="help is-danger">{this.props.message}</p>;
    }

    return (
      <div className="column is-green component-login">
        <h3>Access your account</h3>
        {message}
        <form action="/login" method="post" onSubmit={this.onSubmitLogin}>
          <div className="field input-label">
            <br />
            <label className="label">Email address</label>
            <div className="control">
              <input
                className="input"
                type="email"
                name="username"
                placeholder="Email"
                required
                value={this.state.username}
                onChange={this.onChangeText}
              />
            </div>
          </div>
          <div className="field input-password">
            <label className="label">Password</label>
            {this.renderPassword()}
          </div>
          <div className="field">
            <div className="control">
              <button className="button is-primary is-toppers">Login</button>
            </div>
          </div>
          <div className="field input-password">
            <div className="control">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href={`${process.env.PORTAL_URL}/forgot-password`}
                className="button is-primary is-toppers"
              >
                Forgot Password?
              </a>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

LoginForm.propTypes = {
  message: PropTypes.string,
  loginUser: PropTypes.func,
  setCurrentPageTab: PropTypes.func,
};

const mapStateToProps = (state) => {
  const login = state.login;
  return {
    message: login.message,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginUser: (data) => {
      dispatch(postLoginUser(data));
    },
    setCurrentPageTab: (currentPage, activePage) => {
      dispatch(setCurrentPageTab(currentPage, activePage));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/pages/login/components/loginForm/LoginForm.jsx